import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { AppsIdentifiers, SkinContext } from '@yoti-web-share/skins'

import './PartnershipApps.scss'

import yotiLogo from '../../../assets/apps/yoti/brand-logo.svg'
import easyIDLogo from '../../../assets/apps/easyid/brand-logo.svg'
import smartIDLogo from '../../../assets/apps/smartId/brand-logo.svg'

export const LAYOUTS = {
  STACK: 'stack',
  INLINE: 'inline'
}

const partnershipAppMap = {
  [AppsIdentifiers.EASYID_APP]: easyIDLogo,
  [AppsIdentifiers.YOTI_APP]: yotiLogo,
  [AppsIdentifiers.SMART_ID_APP]: smartIDLogo
}

const PartnershipApps = ({ layout }) => {
  const { supportedApps } = useContext(SkinContext)

  if (supportedApps.length < 2) return null

  return (
    <div
      className={classnames('partnership-apps', `partnership-apps--${layout}`)}
    >
      <span className="partnership-apps__text">
        Works
        {layout === LAYOUTS.INLINE ? <br /> : ' '}
        with:
      </span>
      <div className="partnership-apps__logos">
        {supportedApps.map(({ id, name }, index) => (
          <>
            {index !== 0 && <div className="partnership-apps__divider" />}
            <img src={partnershipAppMap[id]} alt={`${name} logo`} />
          </>
        ))}
      </div>
    </div>
  );
}

PartnershipApps.defaultProps = {
  layout: LAYOUTS.STACK
}

PartnershipApps.propTypes = {
  layout: PropTypes.oneOf(Object.values(LAYOUTS)),
}

export default PartnershipApps
